import React from 'react';
import classnames from 'classnames';
import styles from './FloModal.module.css';
import { FloComponentProps } from 'components';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FloButton, FloButtonType } from 'components/FloButton';
import { noop } from 'lodash';
export interface FloModalBodyProps {
  bindSubmitForm: (submitForm: () => Promise<void | undefined>) => void;
  bindIsFormValid: (isValid: boolean) => void;
}

export interface FloModalFooterProps {
  onSubmit: () => void;
  isFormValid?: boolean;
  isSubmitting?: boolean;
  disabled?: boolean;
  closeOnSubmit?:     boolean;
  onHide: () => void;
}

export interface FloModalHeaderProps {}

export interface FloModalProps extends FloComponentProps {
  name:               string;
  title:              string;
  body:               (props: FloModalBodyProps) => React.ReactNode;
  footer?:            (props: FloModalFooterProps) => React.ReactNode;
  header?:            (props: FloModalHeaderProps) => React.ReactNode;
  show:               boolean;
  disableHide?:       boolean;
  onHide:             () => void;
  isSubmitting?:      boolean;
  closeOnSubmit?:     boolean;
  disableButtons?:    boolean;
  submitDisplayText?: string;
}

export class FloModal extends React.PureComponent<FloModalProps> {
  private submitForm: (() => Promise<void | undefined>) | null;
  static DefaultActions: React.FC<DefaultActionsProps>;

  constructor(props: FloModalProps) {
    super(props);
    this.submitForm = null;
    this.state = {
      isFormValid: true
    }
  }

  bindIsFormValid = (isValid: boolean) => {
    this.setState({ isFormValid: isValid });
  }

  bindSubmitForm = (newSubmitForm: () => Promise<void | undefined>) => {
    this.submitForm = newSubmitForm;
  }

  handleOnSubmit = () => {
    if (this.submitForm !== null) {
      this.submitForm();
    }
  }

  render() {
    const {className, title, name, body, footer, header, isSubmitting, disableButtons, disableHide, closeOnSubmit, onHide, submitDisplayText, ...rest} = this.props;
    const footerComp = footer || ((props) => <DefaultActions {...props} submitDisplayText={submitDisplayText} />);
    const headerComp = header || ((props) => <Modal.Title id={name} className={styles.title}>{title}</Modal.Title>);
    return (
      <Modal
        {...rest}
        onHide            = {disableHide ? noop : onHide}
        className         = {classnames(styles.root, className)}
        aria-labelledby   = {name}
      >
        <Modal.Header closeButton className={styles.header}>
          {headerComp({})}
        </Modal.Header>
        <Modal.Body>
          { body({bindSubmitForm: this.bindSubmitForm, bindIsFormValid: this.bindIsFormValid}) }
        </Modal.Body>
        { footerComp &&
          <Modal.Footer className={styles.footer}>
            {footerComp({
              onSubmit: this.handleOnSubmit,
              isFormValid: (this.state as any).isFormValid,
              isSubmitting: isSubmitting,              
              disabled: disableButtons,
              closeOnSubmit: closeOnSubmit,
              onHide: onHide,              
            })}
          </Modal.Footer>
        }
      </Modal>
    );
  }
}

export interface DefaultActionsProps extends FloModalFooterProps {
  submitDisplayText?: string;
}

const DefaultActions: React.FC<DefaultActionsProps> = ({onSubmit, isSubmitting, disabled, isFormValid, submitDisplayText, closeOnSubmit, onHide = () => {}}) => {
  const { t } = useTranslation('flo-components');
  const submitText = submitDisplayText ? submitDisplayText : t('Save Changes');
  return (
    <>
      <FloButton
        text       = {t('Cancel')}
        type       = {FloButtonType.SECONDARY}
        onClick    = {() => onHide()}
      />
      <FloButton
        text       = {submitText}
        onClick    = {() => {
          onSubmit();
            if(closeOnSubmit){
              onHide();
            }
        }}
        showLoader = {isSubmitting}
        disabled   = {disabled || !isFormValid}
      />
    </>
  )
}

FloModal.DefaultActions = DefaultActions;

export default FloModal;
